import { a2Notes } from './a2Notes';
import { verbs } from './verbs';
import { nouns } from './nouns';
import { articles } from './articles';
import { cases } from './cases';
import { pronouns } from './pronouns';
import { adjectives } from './adjectives';
import { adverbs } from './adverbs';
import { prepositions } from './prepositions';
import { conjunctions } from './conjunctions';
import { sentenceStructure } from './sentenceStructure';
import { subordinateClauses } from './subordinateClauses';
import { relativeClauses } from './relativeClauses';
import { passive } from './passive';
import { questions } from './questions';
import { imperative } from './imperative';
import { particles } from './particles';
import { wordFormation } from './wordFormation';
import { style } from './style';

export const ALL_GRAMMAR_TOPICS = [
  ...a2Notes,
  ...verbs,
  ...nouns,
  ...articles,
  ...cases,
  ...pronouns,
  ...adjectives,
  ...adverbs,
  ...prepositions,
  ...conjunctions,
  ...sentenceStructure,
  ...subordinateClauses,
  ...relativeClauses,
  ...passive,
  ...questions,
  ...imperative,
  ...particles,
  ...wordFormation,
  ...style
];

export const CEFR_LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];

export const GRAMMAR_CATEGORIES = [
  { id: 'a2_notes', title: 'A2 Shënimet e Mia (Leksionet 1-13)', icon: 'BookOpenIcon' },
  { id: 'verbs', title: 'Verben (Foljet)', icon: 'SparklesIcon' },
  { id: 'nomen', title: 'Nomen (Emrat)', icon: 'TagIcon' },
  { id: 'artikel', title: 'Artikel (Nyjet)', icon: 'Bars3Icon' },
  { id: 'kasus', title: 'Kasus (Rastet)', icon: 'ScaleIcon' },
  { id: 'pronomen', title: 'Pronomen (Përemrat)', icon: 'UserIcon' },
  { id: 'adjektive', title: 'Adjektive (Mbiemrat)', icon: 'PaintBrushIcon' },
  { id: 'adverbien', title: 'Adverbien (Ndajfoljet)', icon: 'ClockIcon' },
  { id: 'prepositions', title: 'Präpositionen (Parafjalët)', icon: 'LinkIcon' },
  { id: 'konjunktionen', title: 'Konjunktionen (Lidhëzat)', icon: 'ArrowsRightLeftIcon' },
  { id: 'satzbau', title: 'Satzbau (Struktura)', icon: 'RectangleGroupIcon' },
  { id: 'nebe', title: 'Nebensätze', icon: 'ListBulletIcon' },
  { id: 'relativsatz', title: 'Relativsätze', icon: 'ArrowsPointingInIcon' },
  { id: 'passiv', title: 'Passiv (Pësorja)', icon: 'ArrowPathIcon' },
  { id: 'fragen', title: 'Fragen (Pyetjet)', icon: 'QuestionMarkCircleIcon' },
  { id: 'imperativ', title: 'Imperativ (Urdhërorja)', icon: 'MegaphoneIcon' },
  { id: 'partikeln', title: 'Partikeln (Pjesëzat)', icon: 'ChatBubbleBottomCenterTextIcon' },
  { id: 'wortbildung', title: 'Wortbildung', icon: 'PuzzlePieceIcon' },
  { id: 'stil', title: 'Stil & Struktura', icon: 'BeakerIcon' }
];
